export const setPageHeader = (title = 'OnTrack', description = null) => {
	document.title = title

	if (description) {
		const descriptionTag = document.querySelector('meta[name="description"]')
		if (descriptionTag) {
			descriptionTag.setAttribute('content', t(description))
		}
	}
}
